import { useDocument } from 'hooks';

export type usePuzzleParams = {
  puzzleId: string;
};

const usePuzzle = ({ puzzleId }: usePuzzleParams) => {
  const { state, data } = useDocument(`/puzzles/${puzzleId}`, false);

  return {
    state,
    data,
  };
};

export default usePuzzle;
